import { General, Base64 } from "./modules/General";
import popupMessageSystem from "./modules/PopupMessageSystem";
import popupPickupLista from "./modules/PopupPickupLista";
import ujAdatlapUjarvalaszto from "./modules/UjAdatlapUjarvalaszto";
import ujTermeklistaUjarvalaszto from "./modules/UjTermeklistaUjarvalaszto";
import WebshopListaSzuresStatic from "./modules/WebshopListaSzuresStatic";
import ReceptoldalV2 from "./modules/ReceptoldalV2";
import receptKeresoSuggest from "./modules/ReceptKeresoSuggest";
import Sutikezeles from "./modules/Sutikezeles";
import podorklublogin from "./modules/Podorklublogin";
import Termekajanlo2024 from "./modules/Termekajanlo2024";
import Termekreceptajanlo2024 from "./modules/Termekreceptajanlo2024";
import Countdown from "./modules/Countdown";
import Kereso from "./modules/Kereso";

import MobileMenu2024 from "./modules/MobileMenu2024";

import {
    beuszoControl,
    sargaCsikControl,
    popupSzettLista,
    termekAdatlapVideo,
    termeklistaVideoFelugro,
    NewsletterPopup,
    InfluencerRegisztracio
} from "./modules/WidgetRepresentations";

import {
    spicesMenu,
    spicesPanel
} from "./modules/SpicesControll";

import {GTMDataPusher, FBQDataPusher, GtagDataPusher} from "./modules/MetaDataPushers";
import Kosar from "./modules/Kosar";


document.addEventListener('DOMContentLoaded', function () {
    window['popupMessageSystem'] = new popupMessageSystem();
    window['popupPickupLista'] = new popupPickupLista();
    window['popupSzettLista'] = new popupSzettLista();
    window['spicesMenu'] = new spicesMenu();
    window['spicesPanel'] = new spicesPanel();
    window['termekAdatlapVideo'] = new termekAdatlapVideo();
    window['sargaCsikControl'] = new sargaCsikControl();
    window['ujAdatlapUjarvalaszto'] = new ujAdatlapUjarvalaszto();
    window['ujTermeklistaUjarvalaszto'] = new ujTermeklistaUjarvalaszto();
    window['NewsletterPopup'] = new NewsletterPopup();
    window['InfluencerRegisztracio'] = new InfluencerRegisztracio();
    window['WebshopListaSzuresStatic'] = new WebshopListaSzuresStatic();
    window['termeklistaVideoFelugro'] = new termeklistaVideoFelugro();
    window["GTMDataPusher"] = new GTMDataPusher();
    window["FBQDataPusher"] = new FBQDataPusher();
    window["GtagDataPusher"] = new GtagDataPusher();
    window['ReceptoldalV2'] = new ReceptoldalV2();
    window['receptKeresoSuggest'] = new receptKeresoSuggest();
    window['sutikezeles'] = new Sutikezeles();
    window['podorklublogin'] = new podorklublogin();
    window['Termekajanlo2024'] = new Termekajanlo2024();
    window['Termekreceptajanlo2024'] = new Termekreceptajanlo2024();
    window['MobileMenu2024'] = new MobileMenu2024();
    window['Countdown'] = new Countdown();
    window['Kereso'] = new Kereso();

    window['Base64'] = new Base64();
    window['Kosar'] = new Kosar();

    window['General'] = new General();

});




